<template>
  <dd class="mt-1 whitespace-pre-line text-sm leading-5 text-gray-900">
    <slot />
  </dd>
</template>
